import React, { forwardRef } from "react"
import Select, {
  components,
  createFilter,
  mergeStyles,
} from "react-select"
import { useTranslation } from "react-i18next"

/**
 * Shared react-select wrapper with translated empty-state message.
 * Import this instead of `react-select` for portal dropdowns.
 */
const TranslatedSelect = forwardRef(function TranslatedSelect(props, ref) {
  const { t } = useTranslation()
  const { noOptionsMessage, ...rest } = props

  return (
    <Select
      ref={ref}
      {...rest}
      noOptionsMessage={
        noOptionsMessage || (() => t("No options"))
      }
    />
  )
})

export default TranslatedSelect
export { components, createFilter, mergeStyles }
